module.exports = __webpack_public_path__ + "media/Audio16_a.c1637f9d.wav";